import { render, staticRenderFns } from "./RelatedPurchaseOrRemortgage.vue?vue&type=template&id=495482fc&"
import script from "./RelatedPurchaseOrRemortgage.vue?vue&type=script&lang=js&"
export * from "./RelatedPurchaseOrRemortgage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports